// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoIndex from "./RedirectoIndex";
import SignupForm from "./Signup";
import LoginForm from "./Login";
import { ieCheck } from "../../global/functions/ieCheck";

class Switch extends Component<*> {
  constructor(props) {
    super(props);
  }

  changePage(url: string) {
    if (!ieCheck()) {
      document.querySelector("#picker").classList.toggle("hover");
      //document.querySelector("#picker").classList.toggle("white");
      //document.querySelector("#picker").classList.toggle("green");
    }
    else if (parseInt(ieCheck()) > 11) {
      document.querySelector("#picker").classList.toggle("hover");
      //document.querySelector("#picker").classList.toggle("white");
      //document.querySelector("#picker").classList.toggle("green");
    }
    else {
      window.location.href = url;
    }
  }

  render(): React$Element<*> {
    const isSignupPage = (this.props.location.pathname == "/signup");
    const SwitchComponent = (): React$Element<*> => (
      <div id="picker" className={(isSignupPage ? "flip-container white" : "flip-container white")}>
        <div className="flipper">
          <div className={isSignupPage ? "back" : "front"}>
            <LoginForm changePage={(): * => this.changePage("/signup")} />
          </div>
          <div className={isSignupPage ? "front" : "back"}>
            <SignupForm changePage={(): * => this.changePage("/login")} />
          </div>
        </div>
      </div>
    );
    return (
      <UserAuth principal='user' unAuthChildren={<SwitchComponent />}>
        <RedirectoIndex />
      </UserAuth>
    );
  }
}


export default Switch;
